const WalletHeader = () => {
  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
        My Wallet
      </h1>
      <p className="text-xs sm:text-sm text-slate-500 mt-1">
        Commissions from traveller reservations, partner earnings and payout settlements.
      </p>
    </div>
  );
};

export default WalletHeader;
